// @ts-nocheck

import styled from 'styled-components';

const RulesWrapper = styled.div`
  width: 100%;
  padding: 1em 2em;
  margin: 1em 0;
  background: #111111bb;
  border-radius: 0.75em;
  font-family: 'BettingArchivoNarrow';
`;

const RulesHeader = styled.div`
  text-align: center;
  margin-bottom: 0.5em;
  font-size: 1.2em;
  font-weight: bold;
`;

const RulesList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 1em;
  font-size: 0.96em;
  align-items: start;
  list-style-type: disc;
`;

const Rule = styled.li`
  &:not(:last-child) {
    margin-bottom: 0.5em;
  }
`;

type RulesDetailsProps = {
  className?: string;
  rules: Array<unknown>;
};

const KLOrientationStepRulesDetails = ({ rules, className = '' }: RulesDetailsProps) => (
  <RulesWrapper className={className}>
    <RulesHeader>Objectif{rules.length > 1 ? 's' : ''}</RulesHeader>
    <RulesList>
      {rules.map((rule, i) => (
        <Rule key={`step-rule-${i}`}>{rule}</Rule>
      ))}
    </RulesList>
  </RulesWrapper>
);

export default KLOrientationStepRulesDetails;
